import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { WalletReportFilterModel } from 'src/app/models/wallet/wallet-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletReportService {

  constructor(private _httpClient: HttpClient) { }

  exportWalletReportCollectionBySeller(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportCollectionBySeller}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportDetailedAccountStatement(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportDetailedAccountStatement}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportGeneratedReceipts(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportGeneratedReceipts}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportPaymentsByClient(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportPaymentsByClient}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportSummaryAccountStatement(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportSummaryAccountStatement}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportTotalIncomePerMonth(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportTotalIncomePerMonth}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportWallet(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportWallet}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportWalletReportWalletBalance(walletReportFilterModel: WalletReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.ExportWalletReportWalletBalance}`, walletReportFilterModel, {
      responseType: 'blob',
    });
  }

  getAllIncomeConceptsByBranchForSelectAsync(branchId: number): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.GetAllIncomeConceptsByBranchForSelectAsync}/${branchId}`);
  }

  getAllInvoiceWalletTypesForSelectAsync(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.GetAllInvoiceWalletTypesForSelectAsync}`,);
  }

  walletReportCollectionBySeller(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportCollectionBySeller}`,
      walletReportFilterModel);
  }

  walletReportDetailedAccountStatement(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportDetailedAccountStatement}`,
      walletReportFilterModel);
  }

  walletReportGeneratedReceipts(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportGeneratedReceipts}`,
      walletReportFilterModel);
  }

  walletReportPaymentsByClient(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportPaymentsByClient}`,
      walletReportFilterModel);
  }

  walletReportSummaryAccountStatement(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportSummaryAccountStatement}`,
      walletReportFilterModel);
  }

  walletReportTotalIncomePerMonth(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportTotalIncomePerMonth}`,
      walletReportFilterModel);
  }

  walletReportWallet(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportWallet}`,
      walletReportFilterModel);
  }

  walletReportWalletBalance(walletReportFilterModel: WalletReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletReport.WalletReportWalletBalance}`,
      walletReportFilterModel);
  }
}
